import { isDefined } from "@clipboard-health/util-ts";

import { hideKeyboard as hideKeyboardNative } from "../../../NativeAdapters/keyboard.adapter";

export async function hideKeyboard() {
  const activeElement = document.activeElement as HTMLElement;

  if (isDefined(activeElement)) {
    activeElement.blur?.();
  }

  // The adapter handles platform checks internally
  hideKeyboardNative().catch(() => {
    // Ignore errors
  });
}
